import { render, staticRenderFns } from "./AddProfilePage.vue?vue&type=template&id=0cc54cb8&"
import script from "./AddProfilePage.vue?vue&type=script&lang=js&"
export * from "./AddProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports